import { useContext } from "react";
import _ from "lodash";
import { getLastIndex, removeLastIndex } from "lib/helpers";
import { rootNamespace } from "config";
import { TreeContext } from "pages/Editor";

// function onChange(callback) {
//   return ({ target: { value } }) => callback(value);
// }

/**
 *
 * @param {string} attribute
 * @param {boolean} selected decide between selected & in context component<br>in context is also set by dragcontainer
 */
export function useAttribute(attribute, selected = true) {
  const { selection, component, update } = useContext(TreeContext);
  let value;
  if (selected) value = _.get(selection, "component.attribute." + attribute);
  // set by immediate parent. eg. DragContainer
  else value = _.get(component, "attribute." + attribute);
  const values = [value];
  if (selected)
    values.push((value) => {
      selection.ref[attribute] = value;
      update(selection.path + ".attribute", { [attribute]: value });
    });
  return values;
}

export function useAttributeSetter(attribute) {
  const { selection } = useContext(TreeContext);
  return (value) => {
    selection.ref[attribute] = value;
  };
}

/**
 *
 * @param {string} attribute
 * @param {boolean} loadStyle use computed style if data not present
 */
export function useStyle(attribute, loadStyle = true) {
  const { selection, update } = useContext(TreeContext);
  let value;
  if (Array.isArray(attribute)) {
    value = {};
    const foo = {};
    for (let key of attribute) {
      // style from component data
      let target = _.get(selection, "component.style." + key);
      if (target) foo[key] = target;
      // computed style
      if (loadStyle && !target) {
        target = _.get(selection, "style." + key);
        if (target) foo[key] = "computed style";
      }
      if (target) {
        value[key] = target;
      }
    }
    // if(path === 'abc.children.0') console.log(foo, loadStyle);
  } else {
    // style from component
    // load full style if attribute not specified see issue #2
    value = attribute
      ? _.get(selection, "component.style." + attribute)
      : _.get(selection, "component.style");
    // computed style
    if (loadStyle && !value) value = _.get(selection, "style." + attribute);
  }
  return [
    value,
    (value, updateTree = true) => {
      const target = {};
      if (typeof value === "object") {
        for (let key in value) {
          const v = value[key];
          target[key] = v;
          // TODO: remove message
          // removed direct style update
        }
      } else {
        target[attribute] = value;
        // TODO: remove message
        // removed direct style update
      }
      // console.log(target)
      if (updateTree) update(selection.path + ".style", target);
    },
  ];
}

/**
 * used with lists
 *
 * @param {string} path target path
 */
export function useDrop(path) {
  const { publish } = useContext(TreeContext);
  return (data) => {
    const { action } = data;
    if (action === "ADD") {
      const { item } = data;
      publish(rootNamespace, "ADD", { path, item });
    }
    if (action === "MOVE") {
      const { from } = data;
      // TODO: check if correction required
      // index correction
      let index = getLastIndex(path);
      if (getLastIndex(from) < index) {
        path = removeLastIndex(path) + "." + (index - 1);
      }
      publish(rootNamespace, "MOVE", { from, to: path });
    }
  };
}
